import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretLeftIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 6,
	height: 13,
	viewBox: "0 0 6 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5.52013 0.189899C5.7384 0.359056 5.77821 0.673125 5.60905 0.891392L1.41785 6.29939L5.60905 11.7074C5.77821 11.9257 5.7384 12.2397 5.52013 12.4089C5.30186 12.578 4.98779 12.5382 4.81864 12.32L0.390065 6.60568C0.250342 6.42539 0.250342 6.17339 0.390065 5.99311L4.81864 0.278821C4.98779 0.0605537 5.30186 0.0207421 5.52013 0.189899Z",
		fill: "#212121"
	})
});
export default SvgCaretLeftIcon;
